



















import { Component, Mixins, Inject } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

@Component
export default class extends Mixins(AxPage) {
  @Inject()
  setLoading!: (sw: boolean) => void;
}
